/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type GetOrgRateLimitAuthOrgsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class GetOrgRateLimitAuthOrgsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgRateLimitAuthOrgsResponse429ResponseBodyData;

  constructor(
    err: GetOrgRateLimitAuthOrgsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgRateLimitAuthOrgsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type GetOrgRateLimitAuthOrgsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class GetOrgRateLimitAuthOrgsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgRateLimitAuthOrgsResponse409ResponseBodyData;

  constructor(
    err: GetOrgRateLimitAuthOrgsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgRateLimitAuthOrgsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type GetOrgRateLimitAuthOrgsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class GetOrgRateLimitAuthOrgsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgRateLimitAuthOrgsResponse404ResponseBodyData;

  constructor(
    err: GetOrgRateLimitAuthOrgsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgRateLimitAuthOrgsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type GetOrgRateLimitAuthOrgsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class GetOrgRateLimitAuthOrgsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgRateLimitAuthOrgsResponseResponseBodyData;

  constructor(
    err: GetOrgRateLimitAuthOrgsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgRateLimitAuthOrgsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type GetOrgRateLimitAuthOrgsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class GetOrgRateLimitAuthOrgsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgRateLimitAuthOrgsResponseBodyData;

  constructor(
    err: GetOrgRateLimitAuthOrgsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgRateLimitAuthOrgsResponseBody";
  }
}

/**
 * Bad request
 */
export type GetOrgRateLimitResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class GetOrgRateLimitResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgRateLimitResponseBodyData;

  constructor(
    err: GetOrgRateLimitResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgRateLimitResponseBody";
  }
}

/** @internal */
export const GetOrgRateLimitAuthOrgsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetOrgRateLimitAuthOrgsResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetOrgRateLimitAuthOrgsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgRateLimitAuthOrgsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    GetOrgRateLimitAuthOrgsResponse429ResponseBody
  > = z.instanceof(GetOrgRateLimitAuthOrgsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetOrgRateLimitAuthOrgsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetOrgRateLimitAuthOrgsResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetOrgRateLimitAuthOrgsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgRateLimitAuthOrgsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    GetOrgRateLimitAuthOrgsResponse409ResponseBody
  > = z.instanceof(GetOrgRateLimitAuthOrgsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetOrgRateLimitAuthOrgsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetOrgRateLimitAuthOrgsResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetOrgRateLimitAuthOrgsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgRateLimitAuthOrgsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    GetOrgRateLimitAuthOrgsResponse404ResponseBody
  > = z.instanceof(GetOrgRateLimitAuthOrgsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetOrgRateLimitAuthOrgsResponseResponseBody$inboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetOrgRateLimitAuthOrgsResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetOrgRateLimitAuthOrgsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgRateLimitAuthOrgsResponseResponseBody$outboundSchema:
  z.ZodType<
    GetOrgRateLimitAuthOrgsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    GetOrgRateLimitAuthOrgsResponseResponseBody
  > = z.instanceof(GetOrgRateLimitAuthOrgsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetOrgRateLimitAuthOrgsResponseBody$inboundSchema: z.ZodType<
  GetOrgRateLimitAuthOrgsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetOrgRateLimitAuthOrgsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetOrgRateLimitAuthOrgsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgRateLimitAuthOrgsResponseBody$outboundSchema: z.ZodType<
  GetOrgRateLimitAuthOrgsResponseBody$Outbound,
  z.ZodTypeDef,
  GetOrgRateLimitAuthOrgsResponseBody
> = z.instanceof(GetOrgRateLimitAuthOrgsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetOrgRateLimitResponseBody$inboundSchema: z.ZodType<
  GetOrgRateLimitResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetOrgRateLimitResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetOrgRateLimitResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgRateLimitResponseBody$outboundSchema: z.ZodType<
  GetOrgRateLimitResponseBody$Outbound,
  z.ZodTypeDef,
  GetOrgRateLimitResponseBody
> = z.instanceof(GetOrgRateLimitResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
